import authSaga from './authActions'
import userSaga from './userAction'
import quizSaga from './quizAction'
import {all} from 'redux-saga/effects'



export default function* rootSaga(){
    yield all([
        authSaga(),
        userSaga(),
        quizSaga()
    ])
}